<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2" @click="$router.push('/usuarios')">
        <i class="fas fa-arrow-left"></i> {{$t('volver')}}
      </b-button>
      <b-card-header class="border-0">
        <h3 class="mb-0">{{ $t('usuario') }}: {{ usuario.nombre }} {{ usuario.apellido }}</h3>
      </b-card-header>

      <b-form @submit.prevent="submitForm">
        <div class="d-flex justify-content-end mb-4">          

        <b-button v-if="!isEditPassMode" @click.prevent="isEditMode = !isEditMode;"
          :variant="!isEditMode ? `info` : 'danger'">
          {{ !isEditMode ? $t('editar') : $t('cancelar') }}
        </b-button>

        <b-button v-if="isEditMode" :disabled="!isEditMode" type="submit" variant="primary">
          {{$t('actualizar')}}
        </b-button>

        <b-button v-if="!isEditMode" @click.prevent="isEditPassMode = !isEditPassMode;"
          :variant="!isEditPassMode ? `warning` : 'danger'">
          {{ !isEditPassMode ? $t('editar_contrasena') : $t('cancelar') }}
        </b-button>

        <b-button v-if="isEditPassMode" :disabled="!isEditPassMode" @click.prevent="updatePass()" variant="primary">
          {{$t('actualizar')}}
        </b-button>

        </div>
        <b-row>
          <b-col md="3">
            <b-form-group label-for="Nombre">
              <template v-slot:label>
                {{$t('nombre')}} <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-input id="nombre" :disabled="!isEditMode" v-model="usuario.nombre" required
              :placeholder="$t('ingrese_nombre')"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label-for="Apellido">
              <template v-slot:label>
                {{$t('apellido')}} <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-input id="apellido" :disabled="!isEditMode" v-model="usuario.apellido" required
                :placeholder="$t('ingrese_apellido')"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label-for="Rut">
              <template v-slot:label>
                {{$t('rut')}} <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-input id="rut" :disabled="!isEditMode" v-model="usuario.rut" required
                :placeholder="$t('ingrese_rut')"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">

            <b-form-group label-for="Correo">
              <template v-slot:label>
                {{$t('correo')}} <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-input id="username" :disabled="!isEditMode" v-model="usuario.username" required
                :placeholder="$t('ingrese_correo')"></b-form-input>
            </b-form-group>

          </b-col>

          <b-col v-if="user.id != $route.params.id && user.rol == 'admin'" md="3">
            <b-form-group label="Rol" label-for="rolID">
              <template v-slot:label>
                {{$t('rol')}} <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-select id="rolID" :disabled="!isEditMode" v-model="usuario.rolID"
                required>
                <option :value="null" disabled>{{$t('seleccione_opcion')}}</option>
                <option v-for="option in rolesOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col v-if="user.id != $route.params.id && user.rol == 'admin'" md="3">
            <b-form-group label="Empresa" label-for="empresaID">
              <template v-slot:label>
                {{$t('empresa')}} <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-select id="empresaID" :disabled="!isEditMode" v-model="usuario.empresaID" required>
                <option :value="null" disabled> {{$t('seleccione_opcion')}}</option>
                <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group v-if="isEditPassMode" label-for="Contraseña">
              <template v-slot:label>
                {{$t('contrasena')}}
              </template>
              <b-form-input id="password" :disabled="!isEditPassMode" v-model="password" :state="isPasswordValid"
                placeholder="Ingrese contraseña" @input="validatePassword"></b-form-input>
              <b-form-invalid-feedback>
                {{$t('contrasena_caracteres')}}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </base-header>
  </div>
</template>
<script>
import usuarioService from '@/api/userService';
import miscService from '@/api/miscService';
import utilsService from '@/api/utilsService';
export default {
  data() {
    return {
      isEditMode: false,
      isEditPassMode: false,
      usuario: {},
      empresaOptions: [],
      rolesOptions: [],
      password: '',
      isPasswordValid: null,
    };
  },
  computed: {
    user() {
      const user = utilsService.getUserInfo();
      return user;
    }
  },
  async beforeMount() {
    const id = this.$route.params.id;
    this.usuario = await usuarioService.get(id);
    if (this.user.rol == 'admin') {
      this.rolesOptions = await miscService.getRolesOptions();
      this.empresaOptions = await miscService.getEmpresasOptions();
    }
  },
  methods: {
    validatePassword() {
      this.isPasswordValid = this.password.length >= 5;
    },
    handleSubmit() {
      alert('Contraseña válida y formulario enviado.');
    },
    async submitForm() {
      Swal.fire({
        title: this.$t('estas_seguro'),
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('aceptar'),
        denyButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            const response = await usuarioService.update(this.usuario, this.usuario.id);
            if (!response) throw new Error(this.$t('error_guardar'));
            this.usuario = await usuarioService.get(this.usuario.id);
            this.isEditMode = false;
            Swal.fire({
              title: this.$t('cambios_guardados'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: this.$t('error_2')
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    },
    async updatePass() {
      Swal.fire({
        title: this.$t('estas_seguro'),
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('aceptar'),
        denyButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {

            if (this.password == '' || this.password.length < 5)  throw new Error(this.$t('contrasena_caracteres'));
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            const response = await usuarioService.updatePass(this.password, this.usuario.id);
            if (!response) throw new Error(this.$t('error_actualizar_contrasena'));
            this.usuario = await usuarioService.get(this.usuario.id);
            this.isEditMode = false;
            this.isEditPassMode = false;
            Swal.fire({
              title: this.$t('cambios_guardados'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    }


  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
